import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { RecoveryMagicLinkPage } from '@egw/features-auth'

export const PasskeyRecoveryMagicLinkPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.recovery.title')} />
      <RecoveryMagicLinkPage />
    </Layout>
  )
}
